import { useTheme } from '@emotion/react';
import {
  Button,
  CircularProgress,
  Dialog,
  Divider,
  Grid,
  MenuItem,
  Popover,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { discussWithAgent, offerWithdrawVendor } from 'api/apiService';
import { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import Loading from 'assets/images/loading.png';
import {
  fontsize14,
  menuitemfont,
  poppins400,
  poppins500,
} from 'theme/common.style';
import ManageOffer from './ManageOffer';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import VendorSelectMenuDrawer from './VendorSelectMenuDrawer';

export const ActionDown = () => {
  return (
    <svg
      width="9"
      height="6"
      viewBox="0 0 9 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.464561 0.755281C0.622835 0.597365 0.870509 0.583009 1.04504 0.712213L1.09504 0.755281L4.66732 4.31961L8.23959 0.755281C8.39787 0.597365 8.64554 0.583009 8.82007 0.712213L8.87007 0.755281C9.02835 0.913197 9.04274 1.16031 8.91324 1.33444L8.87007 1.38433L4.98256 5.26305C4.82428 5.42096 4.57661 5.43532 4.40208 5.30611L4.35208 5.26305L0.464561 1.38433C0.290459 1.21062 0.290459 0.928989 0.464561 0.755281Z"
        fill="black"
      />
    </svg>
  );
};
const DiscusAgent = () => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9182 1.71376C11.0141 1.41437 10.0298 1.25 9 1.25C4.58172 1.25 1 4.27594 1 8.00862C1 9.46604 1.54603 10.8157 2.4747 11.9196L1.5 16.5L5.41607 14.0527C6.49418 14.5099 7.71152 14.7672 9 14.7672C13.4183 14.7672 17 11.7413 17 8.00862C17 7.32386 16.8795 6.66288 16.6553 6.04001"
        stroke="#9401B9"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 1V5"
        stroke="#9401B9"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17 3H13"
        stroke="#9401B9"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const ViewAllOff = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_25447_51386)">
        <path
          d="M9.16602 5H16.666"
          stroke="#2F3F5E"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.16602 10H16.666"
          stroke="#2F3F5E"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 15H16.6667"
          stroke="#2F3F5E"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.33398 13.3327C3.33398 12.8907 3.50958 12.4667 3.82214 12.1542C4.1347 11.8416 4.55862 11.666 5.00065 11.666C5.44268 11.666 5.8666 11.8416 6.17916 12.1542C6.49172 12.4667 6.66732 12.8907 6.66732 13.3327C6.66732 13.8252 6.25065 14.166 5.83398 14.5827L3.33398 16.666H6.66732"
          stroke="#2F3F5E"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.00065 8.33398V3.33398L3.33398 5.00065"
          stroke="#2F3F5E"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_25447_51386">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const WithdrawLastAct = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.34314 3.58142C6.46733 0.457234 11.5326 0.457234 14.6569 3.58142C17.781 6.70561 17.781 11.7709 14.6569 14.8952C11.5326 18.0193 6.46733 18.0193 3.34314 14.8952C0.218952 11.7709 0.218952 6.70561 3.34314 3.58142Z"
        stroke="#2F3F5E"
        stroke-linecap="round"
      />
      <path
        d="M3.66602 3.9043L14.3327 14.5709"
        stroke="#2F3F5E"
        stroke-linecap="round"
      />
    </svg>
  );
};
const Warning = () => {
  return (
    <svg
      width="38"
      height="36"
      viewBox="0 0 38 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="37.5797"
        height="36"
        rx="18"
        fill="#10D35E"
        fill-opacity="0.1"
      />
      <path
        d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
        fill="#10D35E"
      />
    </svg>
  );
};
const Offer = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33233 7.80887L5.33168 7.82033C5.28733 8.5971 5.72244 9.32479 6.44047 9.67366L6.44784 9.67726C6.70098 9.79835 6.90847 9.99798 7.03938 10.2462L7.04232 10.2516C7.40412 10.9405 8.15242 11.3581 8.95015 11.3162L8.96226 11.3156C9.25156 11.2994 9.53874 11.374 9.78354 11.5291C10.459 11.9516 11.3165 11.9516 11.992 11.5291C12.2368 11.374 12.5239 11.2994 12.8133 11.3156L12.8254 11.3162C13.6218 11.3584 14.3711 10.9405 14.7337 10.2505L14.7355 10.2467C14.8669 9.99782 15.0749 9.79786 15.3288 9.67661L15.3347 9.67366C16.0527 9.32463 16.488 8.5971 16.4435 7.82016L16.4428 7.80936C16.4281 7.53576 16.504 7.26495 16.6592 7.03897C17.1057 6.3877 17.1057 5.52894 16.6593 4.87751C16.5044 4.65169 16.4281 4.38104 16.4428 4.10744L16.4435 4.09599C16.488 3.31905 16.0527 2.59152 15.3341 2.24233L15.3275 2.23905C15.0749 2.11829 14.8679 1.91964 14.7368 1.67206L14.733 1.66469C14.3711 0.975788 13.6218 0.558355 12.8254 0.600082L12.8131 0.600736C12.5239 0.616936 12.2368 0.542319 11.9921 0.387192H11.9918C11.3163 -0.0353141 10.4589 -0.0353141 9.78338 0.387192C9.53858 0.542155 9.2514 0.616773 8.96209 0.600573L8.94998 0.599918C8.15341 0.5577 7.40428 0.975625 7.04249 1.66437L7.0397 1.66944C6.90863 1.91816 6.70098 2.11796 6.44751 2.23922L6.44064 2.24249C5.7226 2.59136 5.28733 3.31905 5.33184 4.09599L5.3325 4.10679C5.34722 4.38038 5.2713 4.6512 5.11617 4.87702C4.66961 5.52845 4.66961 6.38737 5.11617 7.03864C5.27113 7.26446 5.34722 7.53527 5.33233 7.80887ZM5.66779 5.25763C5.90718 4.90909 6.02451 4.49117 6.0016 4.06899L6.00095 4.05753C5.97738 3.54274 6.26636 3.06459 6.73289 2.84581L6.73862 2.84303C7.12136 2.65976 7.43472 2.35802 7.63239 1.98264L7.63566 1.97642C7.87604 1.51857 8.37955 1.24104 8.91431 1.26951L8.92609 1.27C9.354 1.29406 9.77863 1.18377 10.1406 0.954352C10.5976 0.668481 11.1776 0.668481 11.6346 0.954352C11.9965 1.18344 12.4212 1.2939 12.8489 1.27017L12.8607 1.26951C13.3981 1.24137 13.8991 1.51857 14.1389 1.97511L14.1433 1.98345C14.341 2.35834 14.654 2.6596 15.0362 2.8427L15.0418 2.84549C15.5157 3.07588 15.8034 3.55157 15.7744 4.0577L15.7737 4.06964C15.7508 4.49182 15.8683 4.90958 16.1077 5.25812C16.397 5.68014 16.3969 6.2365 16.1074 6.65835C15.8682 7.00706 15.7508 7.42498 15.7737 7.84716L15.7744 7.85845C15.8034 8.36458 15.5157 8.84043 15.0416 9.07099L15.0367 9.07328C14.6537 9.25688 14.34 9.55895 14.1421 9.93499L14.1397 9.93989C13.8991 10.3977 13.3964 10.6754 12.8609 10.6468L12.8492 10.6461C12.4213 10.6223 11.9965 10.7327 11.6344 10.962C11.1776 11.2477 10.5976 11.2477 10.1408 10.962C9.81152 10.7533 9.4296 10.6427 9.03982 10.643C9.00202 10.643 8.96406 10.644 8.92609 10.6461L8.91431 10.6466C8.38659 10.6802 7.88734 10.404 7.63517 9.93908L7.63174 9.93269C7.43439 9.55797 7.12152 9.25688 6.73943 9.07377L6.73322 9.07066C6.25916 8.84027 5.97149 8.36441 6.00062 7.85845L6.00127 7.84651C6.02402 7.42433 5.90653 7.0064 5.66729 6.65802C5.37815 6.23601 5.37831 5.67965 5.66779 5.25796V5.25763Z"
        fill="#2F3F5E"
      />
      <path
        d="M12.5512 7.05174C12.5512 7.31841 12.4846 7.56908 12.3512 7.80374C12.2232 8.03841 12.0312 8.23574 11.7752 8.39574C11.5246 8.55574 11.2259 8.65174 10.8792 8.68374V9.33174H10.3592V8.68374C9.85789 8.63574 9.45255 8.47841 9.14322 8.21174C8.83389 7.94508 8.67922 7.59308 8.67922 7.15574H9.65522C9.67122 7.36374 9.73789 7.53708 9.85522 7.67574C9.97255 7.80908 10.1406 7.89441 10.3592 7.93174V6.17174C10.0019 6.08108 9.71122 5.99041 9.48722 5.89974C9.26322 5.80374 9.07122 5.65441 8.91122 5.45174C8.75655 5.24908 8.67922 4.97174 8.67922 4.61974C8.67922 4.17708 8.83389 3.81174 9.14322 3.52374C9.45255 3.23041 9.85789 3.05974 10.3592 3.01174V2.36374H10.8792V3.01174C11.3486 3.05441 11.7246 3.20374 12.0072 3.45974C12.2952 3.71041 12.4579 4.05708 12.4952 4.49974H11.5192C11.5032 4.33441 11.4392 4.18774 11.3272 4.05974C11.2152 3.92641 11.0659 3.83574 10.8792 3.78774V5.51574C11.2366 5.60108 11.5272 5.69174 11.7512 5.78774C11.9752 5.87841 12.1646 6.02508 12.3192 6.22774C12.4739 6.42508 12.5512 6.69974 12.5512 7.05174ZM9.60722 4.57174C9.60722 4.79041 9.67122 4.96108 9.79922 5.08374C9.93255 5.20641 10.1192 5.30508 10.3592 5.37974V3.76374C10.1299 3.79041 9.94589 3.87308 9.80722 4.01174C9.67389 4.15041 9.60722 4.33708 9.60722 4.57174ZM10.8792 7.93174C11.1139 7.89441 11.2979 7.80108 11.4312 7.65174C11.5646 7.49708 11.6312 7.31308 11.6312 7.09974C11.6312 6.88641 11.5646 6.72108 11.4312 6.60374C11.3032 6.48108 11.1192 6.38241 10.8792 6.30774V7.93174Z"
        fill="#2F3F5E"
      />
      <path
        d="M17.9565 13.1953C17.5127 12.4077 16.5286 12.1078 15.7211 12.5139L13.0959 13.7543C12.7334 13.0803 12.0381 12.6512 11.273 12.6296L8.84953 12.5629C8.4658 12.5519 8.08928 12.4545 7.7481 12.2785L7.5015 12.1507C6.23889 11.4925 4.73394 11.4942 3.47263 12.1549L3.48802 11.5963C3.49309 11.4112 3.34729 11.2571 3.16222 11.252L0.50478 11.1788C0.319708 11.1738 0.165727 11.3196 0.160655 11.5046L0.000128454 17.3364C-0.00494426 17.5215 0.140855 17.6757 0.325926 17.6807L2.98336 17.7539H2.99269C3.17416 17.7537 3.32258 17.6092 3.32765 17.4279L3.33518 17.1489L4.02556 16.7793C4.29654 16.6335 4.6135 16.5988 4.90952 16.6825L9.03198 17.8396C9.03918 17.8417 9.04638 17.8434 9.05374 17.845C9.35172 17.9074 9.65543 17.9386 9.95996 17.9385C10.6047 17.9388 11.2419 17.7999 11.8279 17.5308C11.8423 17.5243 11.8562 17.5168 11.8694 17.5083L17.8467 13.6417C17.9958 13.5455 18.0439 13.3496 17.9565 13.1953ZM0.679379 17.0198L0.821414 11.8583L2.80893 11.9129L2.66673 17.0746L0.679379 17.0198ZM11.5258 16.9319C10.7978 17.2605 9.98467 17.3512 9.20216 17.1911L5.09066 16.0373C4.62806 15.9064 4.13258 15.9608 3.70925 16.1884L3.35645 16.3772L3.45103 12.9453C4.56883 12.2017 6.0026 12.1253 7.19321 12.7456L7.43981 12.8734C7.87082 13.096 8.34635 13.2189 8.8312 13.2328L11.2546 13.2996C11.9354 13.319 12.5135 13.8037 12.6516 14.4707L9.0418 14.3714C8.85673 14.3663 8.70275 14.5121 8.69767 14.6972C8.6926 14.8822 8.8384 15.0364 9.02347 15.0415L13.0072 15.1511H13.0167C13.198 15.1509 13.3464 15.0064 13.3515 14.8251C13.3556 14.6795 13.3446 14.5337 13.3191 14.3903L16.0112 13.1181L16.019 13.1143C16.401 12.9209 16.8629 12.9855 17.1769 13.2763L11.5258 16.9319Z"
        fill="#2F3F5E"
      />
    </svg>
  );
};
const NeedHelp = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 21.875C17.6777 21.875 21.875 17.6777 21.875 12.5C21.875 7.32233 17.6777 3.125 12.5 3.125C7.32233 3.125 3.125 7.32233 3.125 12.5C3.125 17.6777 7.32233 21.875 12.5 21.875Z"
        stroke="#EEAD06"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5 17.7085V17.7189"
        stroke="#EEAD06"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5013 14.0627C12.4821 13.7246 12.5733 13.3893 12.7612 13.1075C12.9491 12.8257 13.2235 12.6126 13.543 12.5002C13.9345 12.3505 14.2859 12.1119 14.5696 11.8033C14.8533 11.4947 15.0614 11.1244 15.1777 10.7217C15.2939 10.3189 15.3151 9.89468 15.2396 9.48236C15.164 9.07004 14.9938 8.68089 14.7423 8.34554C14.4907 8.01019 14.1648 7.7378 13.7901 7.54982C13.4155 7.36183 13.0023 7.26338 12.5831 7.26222C12.1639 7.26105 11.7502 7.35721 11.3745 7.54312C10.9988 7.72902 10.6713 7.9996 10.418 8.33355"
        stroke="#EEAD06"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const OpenIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 39 38"
      fill="none"
    >
      <path
        d="M37.7863 19.1323C37.7863 9.03333 29.5995 0.846539 19.5006 0.846539C9.40164 0.846539 1.21484 9.03333 1.21484 19.1323C1.21484 29.2312 9.40164 37.418 19.5006 37.418C29.5995 37.418 37.7863 29.2312 37.7863 19.1323Z"
        stroke="#6C2AD2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.5006 17.3465C19.9094 17.3465 20.36 17.5559 20.7184 17.9143C21.0768 18.2727 21.2863 18.7234 21.2863 19.1322C21.2863 19.5409 21.0769 19.9908 20.7187 20.3485C20.3605 20.7061 19.9098 20.9152 19.5006 20.9152C19.0914 20.9152 18.6406 20.7061 18.2824 20.3485C17.9242 19.9908 17.7148 19.5409 17.7148 19.1322C17.7148 18.7234 17.9243 18.2727 18.2827 17.9143C18.6411 17.5559 19.0917 17.3465 19.5006 17.3465ZM19.5006 26.4893C19.9094 26.4893 20.36 26.6988 20.7184 27.0572C21.0768 27.4156 21.2863 27.8662 21.2863 28.275C21.2863 28.6837 21.0769 29.1336 20.7187 29.4913C20.3605 29.849 19.9098 30.0581 19.5006 30.0581C19.0914 30.0581 18.6406 29.849 18.2824 29.4913C17.9242 29.1336 17.7148 28.6837 17.7148 28.275C17.7148 27.8662 17.9243 27.4156 18.2827 27.0572C18.6411 26.6988 19.0917 26.4893 19.5006 26.4893ZM19.5006 8.20361C19.9094 8.20361 20.36 8.41305 20.7184 8.77145C21.0768 9.12985 21.2863 9.58051 21.2863 9.98933C21.2863 10.398 21.0769 10.8479 20.7187 11.2056C20.3605 11.5633 19.9098 11.7724 19.5006 11.7724C19.0914 11.7724 18.6406 11.5633 18.2824 11.2056C17.9242 10.8479 17.7148 10.398 17.7148 9.98933C17.7148 9.58051 17.9243 9.12985 18.2827 8.77145C18.6411 8.41305 19.0917 8.20361 19.5006 8.20361Z"
        fill="black"
        stroke="#6C2AD2"
      />
    </svg>
  );
};
const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 39 38"
      fill="none"
    >
      <path
        d="M19.5006 37.4181C29.5995 37.4181 37.7863 29.2313 37.7863 19.1324C37.7863 9.03347 29.5995 0.84668 19.5006 0.84668C9.40164 0.84668 1.21484 9.03347 1.21484 19.1324C1.21484 29.2313 9.40164 37.4181 19.5006 37.4181Z"
        stroke="#6C2AD2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.2859 19.1324C21.2859 19.5412 21.0764 19.9919 20.718 20.3503C20.3596 20.7087 19.909 20.9181 19.5001 20.9181C19.0914 20.9181 18.6415 20.7088 18.2839 20.3505C17.9262 19.9923 17.7171 19.5416 17.7171 19.1324C17.7171 18.7232 17.9262 18.2725 18.2839 17.9142C18.6415 17.556 19.0914 17.3467 19.5001 17.3467C19.909 17.3467 20.3596 17.5561 20.718 17.9145C21.0764 18.2729 21.2859 18.7236 21.2859 19.1324ZM12.143 19.1324C12.143 19.5412 11.9336 19.9919 11.5752 20.3503C11.2168 20.7087 10.7661 20.9181 10.3573 20.9181C9.94859 20.9181 9.49869 20.7088 9.14101 20.3505C8.78333 19.9923 8.57422 19.5416 8.57422 19.1324C8.57422 18.7232 8.78333 18.2725 9.14101 17.9142C9.49869 17.556 9.94859 17.3467 10.3573 17.3467C10.7661 17.3467 11.2168 17.5561 11.5752 17.9145C11.9336 18.2729 12.143 18.7236 12.143 19.1324ZM30.4287 19.1324C30.4287 19.5412 30.2193 19.9919 29.8609 20.3503C29.5025 20.7087 29.0518 20.9181 28.643 20.9181C28.2343 20.9181 27.7844 20.7088 27.4267 20.3505C27.069 19.9923 26.8599 19.5416 26.8599 19.1324C26.8599 18.7232 27.069 18.2725 27.4267 17.9142C27.7844 17.556 28.2343 17.3467 28.643 17.3467C29.0518 17.3467 29.5025 17.5561 29.8609 17.9145C30.2193 18.2729 30.4287 18.7236 30.4287 19.1324Z"
        fill="black"
        stroke="#6C2AD2"
      />
    </svg>
  );
};
export default function VendorSelectMenu(props) {
  const {
    onShowChat,
    setOpenBox,
    openBox,
    setPropertyofferId,
    row,
    forwardtobuyer,
    setbuyerOfferPrice,
    setSelectedrowbuyerid,
    setTableChecked,
    tableChecked,
    setForwardtobuyer,
    getListInfo,
    address,
    setCounterOfferDialog,
    setVendorAction,
    setItemObj,
    buyerId,
    propertyDetails,
    tableData,
    acceptLog,
    vendorside,
    vendorDatas,
    setIsSwalOpen,
    setVendorGeneratePdf,
  } = props;

  const [manageOffer, setManageOffer] = useState(false);
  const [openhistorydialog, setOpenhistorydialog] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openWithdrawVendorLoader, setOpenWithdrawVendorLoader] =
    useState(false);
  const [openWithdrawVendor, setOpenWithdrawVendor] = useState(false);
  const [openActionDrawer, setOpenActionDrawer] = useState(false);

  const manageOfferClick = () => {
    setManageOffer(true);
  };

  const manageOfferClickClose = () => {
    setManageOffer(false);
    handleClosee();
  };

  const params = useParams();
  const history = useHistory();

  const handleClicke = (event) => {
    if (matchessm) {
      setOpenActionDrawer(true);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClosee = () => {
    setAnchorEl(null);
  };

  const discussBuyerAgent = (row) => {
    const input = {
      offerUniqueId: row?.buyerOfferDetails?.offerUniqueId,
    };

    discussWithAgent(input).then((res) => {
      handleClosee();
      if (res?.status == 1) {
        onShowChat(res?.binderId);
      }
    });
  };

  const withdrawLast = (offerStatus, offerUniqueId, offerStatusId) => {
    setOpenWithdrawVendorLoader(true);
    const input = {
      offerUniqueId: offerUniqueId,
      offerStatus: offerStatus,
      offerStatusId: offerStatusId,
    };
    offerWithdrawVendor(input)
      .then((res) => {
        if (res?.status == 1) {
          setOpenWithdrawVendor(false);
          Swal.fire({
            title: res?.heading ? res?.heading : 'Success',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          });
          getListInfo('apiupdated', params?.dashboardId);
          setOpenWithdrawVendorLoader(false);
        } else {
          Swal.fire({
            title: res?.heading ? res?.heading : 'Error',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          });
          setOpenWithdrawVendorLoader(false);
        }
      })
      .catch(() => setOpenWithdrawVendorLoader(false));
  };

  const openn = Boolean(anchorEl);
  const id = openn ? 'simple-popover' : undefined;
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (openWithdrawVendorLoader) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [openWithdrawVendorLoader]);

  return (
    <>
      <Grid>
        <Typography aria-describedby={id} onClick={handleClicke}>
          {matchessm ? (
            <Typography aria-describedby={id} onClick={handleClicke}>
              {openn ? <CloseIcon /> : <OpenIcon />}
            </Typography>
          ) : (
            <Button
              onClick={handleClicke}
              sx={[
                menuitemfont,
                {
                  ...poppins400,
                  fontSize: matchessm ? '8px' : '14px',
                  boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
                  '.MuiOutlinedInput-notchedOutline': { border: 0 },
                  outline: 'none',
                  color: 'black',
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                },
              ]}
            >
              Action &nbsp; &nbsp; <ActionDown />
            </Button>
          )}
        </Typography>
        <Popover
          id={id}
          open={openn}
          anchorEl={anchorEl}
          onClose={handleClosee}
          PaperProps={{
            style: {
              boxShadow: 'none',
              border: '1px solid #D9D9D9',
              borderRadius: '4px',
              minWidth: '274px',
            },
          }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <MenuItem value={20}>
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 400,
                fontSize: '12px',
                color: '#8E8A8A',
                lineHeight: 'normal',
                fontStyle: 'normal',
              }}
            >
              - Offer Status Action -
            </Typography>
          </MenuItem>
          <MenuItem
            value={20}
            disabled={
              row?.buyerOfferDetails?.offerUniqueId == undefined ? true : false
            }
            onClick={() => {
              handleClosee();
              discussBuyerAgent(row);
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 300,
                fontSize: '14px',
                color: '#2F3F5E',
                fontStyle: 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <DiscusAgent /> Discuss with Agent
            </Typography>
          </MenuItem>
          <Divider />
          <MenuItem
            value={20}
            onClick={() => {
              handleClosee();
              manageOfferClick();
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 300,
                fontSize: '14px',
                color: '#2F3F5E',
                fontStyle: 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <Offer /> Manage Offer
            </Typography>
          </MenuItem>
          {(manageOffer || openhistorydialog) && (
            <ManageOffer
              acceptLog={acceptLog}
              open={manageOffer}
              onClose={manageOfferClickClose}
              getListInfo={getListInfo}
              row={row}
              setCounterOfferDialog={setCounterOfferDialog}
              setVendorAction={setVendorAction}
              setItemObj={setItemObj}
              buyerId={buyerId}
              tableData={tableData}
              moxouserId={true}
              setManageOffer={setManageOffer}
              setOpenhistorydialog={setOpenhistorydialog}
              vendorside={vendorside}
              vendorDatas={vendorDatas}
              setIsSwalOpen={setIsSwalOpen}
              setVendorGeneratePdf={setVendorGeneratePdf}
            />
          )}

          <MenuItem value={20} disabled={true}>
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 300,
                fontSize: '14px',
                color: '#2F3F5E',
                fontStyle: 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <ViewAllOff /> View All Offers
            </Typography>
          </MenuItem>

          <Divider />
          <MenuItem
            value={20}
            onClick={() => {
              handleClosee();
              history.push('/helpcentre');
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins!important',
                fontWeight: 300,
                fontSize: '14px',
                color: '#2F3F5E',
                fontStyle: 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <NeedHelp /> Need Help
            </Typography>
          </MenuItem>
        </Popover>
      </Grid>

      <VendorSelectMenuDrawer
        row={row}
        discussBuyerAgent={discussBuyerAgent}
        manageOfferClick={manageOfferClick}
        openhistorydialog={openhistorydialog}
        manageOffer={manageOffer}
        buyerId={buyerId}
        setItemObj={setItemObj}
        setVendorAction={setVendorAction}
        setCounterOfferDialog={setCounterOfferDialog}
        getListInfo={getListInfo}
        manageOfferClickClose={manageOfferClickClose}
        acceptLog={acceptLog}
        vendorDatas={vendorDatas}
        vendorside={vendorside}
        setOpenhistorydialog={setOpenhistorydialog}
        setManageOffer={setManageOffer}
        tableData={tableData}
        open={openActionDrawer}
        setDrawerOpen={setOpenActionDrawer}
        setIsSwalOpen={setIsSwalOpen}
        setVendorGeneratePdf={setVendorGeneratePdf}
      />

      <Dialog
        open={openWithdrawVendor}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : '400px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: '20px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {'   '}
              {tableData?.PropertyDetails?.propertyAddress?.streetName}
              &nbsp;
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Warning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Withdraw Last Action
            </Typography>
          </Grid>
          <Grid item md={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '16px',
                color: '#666666',
              }}
            >
              Do you want to withdraw the last action ?
            </Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            justifyContent={'flex-end'}
            gap={2}
            marginTop={matchessm ? '15px' : 5}
          >
            <Grid item>
              <Button
                disabled={openWithdrawVendorLoader}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
                onClick={() => setOpenWithdrawVendor(false)}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}
            >
              <Button
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
                disabled={openWithdrawVendorLoader}
                onClick={() =>
                  withdrawLast(
                    row?.buyerOfferDetails?.offerStatus,
                    row?.buyerOfferDetails?.offerUniqueId,
                    row?.buyerOfferDetails?.offerStatusId
                  )
                }
              >
                Confirm
              </Button>
              {openWithdrawVendorLoader && (
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
}
